import { render, staticRenderFns } from "./SuppliesClassRegistration.vue?vue&type=template&id=54f45e58&scoped=true&"
import script from "./SuppliesClassRegistration.vue?vue&type=script&lang=js&"
export * from "./SuppliesClassRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f45e58",
  null
  
)

export default component.exports